import { render, staticRenderFns } from "./GoogleReviews.vue?vue&type=template&id=c3d0c3e4&"
import script from "./GoogleReviews.vue?vue&type=script&lang=js&"
export * from "./GoogleReviews.vue?vue&type=script&lang=js&"
import style0 from "./GoogleReviews.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports